import React, { useState, useCallback, useEffect, useRef } from "react";
import styles from "./index.module.scss";
import useSetState from "customHooks/setState";
import { useStore, StoreTypes } from "context";
import * as actionTypes from "constants/actionTypes";
import DialogModule from "components/Dialogs/";
import classnames from "classnames";
import { useLogin } from "util/login";
import { redirectToClubLogin, clubLogout } from "util/naniClub";
import { checkProjectType } from "constants/projectsType";
import { ExchangeContent } from "components/ExchangeContent";
import { useOutsideAlerter } from "customHooks/outsideAlerter";
import { width } from "styled-system";

const Login = ({ open, setOpen }) => {
  const ref = useRef();
  const router = useStore(StoreTypes.router);
  const [{ token, userId, name, isLogin }, userDispatch] = useStore(
    StoreTypes.user
  );
  const [isUserList, setIsUserList] = useState(false);
  const [{ isClassSeletPannel, nowHeadSelectListName }, globalDispatch] =
    useStore(StoreTypes.global);
  const { logoutNaniOneClass, getToken } = useLogin();
  const [isExchange, setIsExchange] = useState(false);

  const login = useCallback(() => {
    // console.log("----name---", name, isLogin);
    if (isLogin) {
      // 先讀出目前 token（logoutNaniOneClass 會清掉 cookie，須在清除前取得）
      const currentToken = getToken();
      router.history.push("/")
      userDispatch({
        type: actionTypes.SET_USER_INFO,
        name: "",
        isLogin: false,
        token: "",
        userId: "",
        product: null,
        isOneLiveMember: null,
        oneLiveMemberCloseTime: null,
      });
      logoutNaniOneClass();
      if (process.env.REACT_APP_PROJECT === "nanistudy") {
        // nanistudy SSO：通知會員中心撤銷 token（clubLogout 內部會清除
        // .nani.com.tw cookie 並導向第三方登出頁或首頁）
        clubLogout(currentToken);
      }
    } else if (process.env.REACT_APP_PROJECT === "nanistudy") {
      // 僅 nanistudy 走南一會員中心 SSO：直接導向會員中心登入，
      // 登入後由 /nani-club-redirect 落地頁還原狀態。先記住目前頁面，登入完成後可導回原處。
      const { pathname, search } = router.location;
      if (pathname && pathname !== "/") {
        document.cookie = `redirect=${pathname}${search || ""}; path=/`;
      }
      redirectToClubLogin();
    } else {
      // 其他專案（onestudy 等）維持原本的帳密／教育雲登入 modal。
      setOpen(!open);
    }
  }, [name, userDispatch, logoutNaniOneClass, getToken, isLogin, router, open, setOpen]);

  const setClose = () => {
    setIsUserList(false);
  };
  useOutsideAlerter(ref, setClose);

  useEffect(() => {});
  const showList = useCallback(() => {
    setIsUserList(!isUserList);
  }, [isUserList]);

  const goClass = () => {
    globalDispatch({ type: actionTypes.SET_VIDEO_LIST, videoList: [] });
    globalDispatch({
      type: actionTypes.SET_NOW_HEAD_LIST_SELECT_NAME,
      nowHeadSelectListName: "我的課程",
    });
    router.history.push(`/PurchaseListView`);
  };
  const goPurchse = () => {
    globalDispatch({
      type: actionTypes.SET_NOW_HEAD_LIST_SELECT_NAME,
      nowHeadSelectListName: "我的訂單",
    });
    router.history.push(`/MyOrders`);
  };
  const goExchange = useCallback(() => {
    setIsExchange(true);
  }, [setIsExchange]);

  const setNaniStyle = () => {
    if (!checkProjectType() && router.location.pathname === "/NaniMainPage") {
      return "nanimainpage";
    } else if (
      !checkProjectType() &&
      router.location.pathname === "/ClassView"
    ) {
      return "naniclassview";
    } else if (!checkProjectType() &&
    router.location.pathname === "/ProductView"){
      return "naniproductview"
    }
  };
  
  return (
    <div ref={ref} className={styles.userInfoArea}>
      <DialogModule
        style={{ "&<width": "100%" }}
        DialogModule
        open={isExchange}
        setOpen={setIsExchange}
        content={<ExchangeContent setIsExchange={setIsExchange} />}
      />
      {isLogin ? (
        <div className={styles.userInfoContent}>
          <div className={styles.userIcon}>
            <div className={styles.nowListText}>
              <div>{nowHeadSelectListName}</div>
            </div>
            <div className={styles.userBtn} onClick={() => showList()}>
              <img src="./assets/img/Avator.png" alt="" />
            </div>
          </div>
          {isUserList && (
            <div className={styles.userList}>
              <div>
                <a className={styles.name}> {name? name: userId}</a>
              </div>
              <div onClick={() => goClass()}>
                <a>我的課程</a>
              </div>
              <div onClick={() => goPurchse()}>
                <a>我的訂單</a>
              </div>
              <div onClick={() => goExchange()}>
                <a>兌換課程</a>
              </div>
              <div onClick={() => login()}>
                <a>登出</a>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div
          className={classnames(styles.loginBtn, styles[setNaniStyle()])}
          onClick={() => login()}
        >
          {
            // console.log(!checkProjectType())
          }
          <div>
            {setNaniStyle() ? (
              "登入/註冊"
            ) : (
              <img src="./assets/img/Enabled.png" alt="" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
export default Login;
